(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this._onClick = this._onClick.bind(this);
        this._onKeydown = this._onKeydown.bind(this);
        this._lastFocus = null;
      }

      connectedCallback() {
        this._onSubToggle = this._onSubToggle.bind(this);
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onSubToggle);
        document.addEventListener('keydown', this._onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onSubToggle);
        document.removeEventListener('keydown', this._onKeydown);
      }

      async _onSubToggle(event) {
        const select = event.target.closest('[data-cart-line-sub-select]');
        if (select) {
          const key = select.dataset.key;
          const nextPlan = select.value || null;
          const previous = select.dataset.previousPlan || '';
          select.disabled = true;
          try {
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, selling_plan: nextPlan })
            });
            if (!res.ok) throw new Error('sub_change_failed');
            this._track(nextPlan ? 'subscription_opt_in' : 'subscription_opt_out', {
              line_key: key,
              selling_plan_id: nextPlan
            });
            await this.refresh();
          } catch (e) {
            select.value = previous;
          } finally {
            select.disabled = false;
          }
          return;
        }

        const swap = event.target.closest('[data-cart-line-variant-swap]');
        if (swap) {
          const key = swap.dataset.key;
          const newVariantId = swap.value;
          const quantity = parseInt(swap.dataset.quantity || '1', 10);
          const sellingPlan = swap.dataset.sellingPlan || null;
          const prevValue = swap.dataset.previousValue || swap.querySelector('option[selected]')?.value;
          swap.disabled = true;
          try {
            // Two-step: /cart/change.js has no variant swap and /cart/update.js merges
            // by variant so a subscribed + one-time same-variant cart would collide.
            // Remove the specific line by key, then add the new variant fresh.
            const remove = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
            if (!remove.ok) throw new Error('variant_swap_remove_failed');
            const addBody = { id: newVariantId, quantity };
            if (sellingPlan) addBody.selling_plan = sellingPlan;
            const add = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify(addBody)
            });
            if (!add.ok) throw new Error('variant_swap_add_failed');
            this._track('variant_change', { line_key: key, new_variant_id: Number(newVariantId), quantity });
            await this.refresh();
          } catch (e) {
            if (prevValue) swap.value = prevValue;
            swap.disabled = false;
          }
        }
      }

      open() {
        this._lastFocus = document.activeElement;
        this.hidden = false;
        void this.offsetWidth;
        this.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        const focusable = this.querySelector('[data-cart-drawer-close], a, button');
        focusable?.focus();
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then((r) => r.json())
          .then((cart) => this._track('view_cart', {
            value: cart.total_price / 100,
            items: cart.items.map((i) => ({ item_id: i.product_id, variant_id: i.variant_id, quantity: i.quantity, price: i.price / 100 }))
          }))
          .catch(() => {});
      }

      close() {
        this.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        setTimeout(() => { this.hidden = true; }, 300);
        if (this._lastFocus && typeof this._lastFocus.focus === 'function') {
          this._lastFocus.focus();
        }
      }

      _track(name, detail) {
        document.dispatchEvent(new CustomEvent('analytics:' + name, { detail: detail || {} }));
      }

      _onClick(event) {
        const cta = event.target.closest('.cart-drawer__cta');
        if (cta && cta.href && cta.href.includes('/checkout')) {
          this._track('begin_checkout', {});
          return;
        }

        if (event.target.closest('[data-cart-drawer-close]')) {
          this.close();
          return;
        }

        const step = event.target.closest('[data-cart-line-step]');
        if (step) {
          event.preventDefault();
          const key = step.dataset.key;
          const delta = parseInt(step.dataset.cartLineStep, 10);
          const valueEl = step.parentElement.querySelector('.cart-line__qty-value');
          const current = parseInt(valueEl?.textContent || '1', 10);
          const next = Math.max(0, current + delta);
          this._updateLine(key, next, current);
          return;
        }

        const remove = event.target.closest('[data-cart-line-remove]');
        if (remove) {
          event.preventDefault();
          this._updateLine(remove.dataset.key, 0, null);
          return;
        }

        const add = event.target.closest('[data-cart-rec-add]');
        if (add) {
          event.preventDefault();
          this._addVariant(add);
          return;
        }

        const subAll = event.target.closest('[data-cart-sub-all]');
        if (subAll) {
          event.preventDefault();
          this._subscribeAll(subAll);
        }
      }

      async _subscribeAll(button) {
        // Every line still on "one-time" converts to its own first available plan.
        // Serial POSTs because /cart/change.js has no bulk selling_plan variant.
        const selects = Array.from(this.querySelectorAll('[data-cart-line-sub-select]'))
          .filter((el) => !el.value && el.dataset.defaultPlan);
        if (!selects.length) return;
        button.disabled = true;
        let converted = 0;
        try {
          for (const el of selects) {
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: el.dataset.key, selling_plan: el.dataset.defaultPlan })
            });
            if (res.ok) converted++;
          }
          this._track('subscription_convert_all', { lines_converted: converted });
          await this.refresh();
        } catch (e) {
          button.disabled = false;
        }
      }

      _onKeydown(event) {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
        }
      }

      async _updateLine(key, quantity, previous) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity })
          });
          if (previous === null || quantity < previous) {
            this._track('remove_from_cart', { item_key: key, quantity_removed: previous === null ? 'all' : previous - quantity });
          }
          await this.refresh();
        } catch (e) { /* no-op */ }
      }

      async _addVariant(button) {
        const id = button.dataset.variantId;
        if (!id) return;
        const labelEl = button.querySelector('[data-cta-label]');
        const label = labelEl.textContent;
        button.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: Number(id), quantity: 1 })
          });
          // 422 here means sold out or already at max quantity. Without this check the
          // button looked like it worked: analytics fired, cart never changed.
          if (!res.ok) throw new Error('add_failed');
          this._track('add_to_cart', { variant_id: Number(id), quantity: 1, source: 'cart_upsell' });
          await this.refresh();
          // No re-enable on success: refresh() replaces innerHTML, so `button` is detached.
        } catch (e) {
          labelEl.textContent = button.dataset.failLabel || label;
          button.disabled = false;
        }
      }

      async refresh() {
        try {
          // ?section_id= (not bulk ?sections=): the bulk API misses cart context on `theme dev`
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(`${root}?section_id=cart-drawer`, {
            headers: { 'Accept': 'text/html' }
          });
          const html = await res.text();
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('cart-drawer');
          if (!newDrawer) return;
          const wasOpen = this.classList.contains('is-open');
          this.innerHTML = newDrawer.innerHTML;
          if (wasOpen) this.classList.add('is-open');

          const countRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          const cart = await countRes.json();
          document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        } catch (e) { /* no-op */ }
      }
    }
    customElements.define('cart-drawer', CartDrawer);
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-cart-drawer]');
    if (!opener) return;
    event.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    drawer?.open?.();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.product-card__form');
    const drawer = document.querySelector('cart-drawer');
    if (!form || !drawer) return; // no drawer -> native POST fallback
    if (!form.closest('.product-card')) return;
    event.preventDefault();
    const button = form.querySelector('.product-card__cta');
    if (button) button.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      if (!res.ok) throw new Error('add failed');
      await drawer.refresh();
      drawer.open();
      try {
        const card = form.closest('.product-card');
        document.dispatchEvent(new CustomEvent('analytics:add_to_cart', {
          detail: {
            item_id: card ? Number(card.dataset.productId) : undefined,
            item_name: card ? card.dataset.productTitle : undefined,
            quantity: 1,
            source: 'product_card'
          }
        }));
      } catch (_) { /* analytics best-effort */ }
    } catch (e) {
      form.submit();
    } finally {
      if (button) button.disabled = false;
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.product-card__link');
    if (!link) return;
    const card = link.closest('.product-card');
    if (!card) return;
    document.dispatchEvent(new CustomEvent('analytics:select_item', {
      detail: { item_id: Number(card.dataset.productId), item_name: card.dataset.productTitle }
    }));
  });

  // Auto-open after the /cart redirect
  function autoOpenIfFlagged() {
    try {
      if (sessionStorage.getItem('open-cart-drawer')) {
        sessionStorage.removeItem('open-cart-drawer');
        document.querySelector('cart-drawer')?.open?.();
      }
    } catch (e) { /* no-op */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoOpenIfFlagged);
  } else {
    autoOpenIfFlagged();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-collection-page]');
    if (!root) return;

    const sectionId = root.dataset.collectionPage;
    let abortController = null;

    function buildUrl(form) {
      const data = new FormData(form);
      const params = new URLSearchParams();
      for (const [key, value] of data.entries()) {
        if (value !== null && value !== undefined && String(value).trim() !== '') {
          params.append(key, value);
        }
      }
      const query = params.toString();
      return window.location.pathname + (query ? '?' + query : '');
    }

    async function applyFilters(url, options) {
      options = options || {};
      if (abortController) abortController.abort();
      abortController = new AbortController();

      root.setAttribute('aria-busy', 'true');

      try {
        const sectionUrl = url + (url.includes('?') ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId);
        const res = await fetch(sectionUrl, { signal: abortController.signal });
        if (!res.ok) throw new Error('Section render failed: ' + res.status);
        const data = await res.json();
        const html = data[sectionId];
        if (!html) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newRoot = doc.querySelector('[data-collection-page]');
        if (!newRoot) return;

        const wasOpen = root.classList.contains('collection-page--filters-open');
        root.innerHTML = newRoot.innerHTML;
        if (wasOpen) root.classList.add('collection-page--filters-open');

        if (!options.skipPushState) {
          history.pushState({ collectionUrl: url }, '', url);
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('[collection async filter]', err);
        }
      } finally {
        root.removeAttribute('aria-busy');
        abortController = null;
      }
    }

    // Toggle the sidebar
    root.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-filter-toggle]');
      if (toggle) {
        event.preventDefault();
        const open = root.classList.toggle('collection-page--filters-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }

      const reset = event.target.closest('.collection-page__reset');
      if (reset) {
        event.preventDefault();
        applyFilters(reset.getAttribute('href'));
        return;
      }
    });

    // Intercept any filter form submission (price Apply button, etc.)
    root.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-filter-form]');
      if (!form) return;
      event.preventDefault();
      try {
        form.querySelectorAll('input[name^="filter."]').forEach((input) => {
          if (input.value !== '' && (input.type !== 'checkbox' || input.checked)) {
            document.dispatchEvent(new CustomEvent('analytics:filter_applied', {
              detail: { filter_name: input.name, filter_value: String(input.value) }
            }));
          }
        });
      } catch (_) { /* analytics best-effort */ }
      applyFilters(buildUrl(form));
    });

    // Auto-apply on input changes (checkboxes, sort dropdown)
    root.addEventListener('change', (event) => {
      const input = event.target.closest('input, select');
      if (!input) return;
      const form = input.form || input.closest('[data-filter-form]') || document.getElementById('collection-filter-form');
      if (!form || !form.matches('[data-filter-form]')) return;
      try {
        document.dispatchEvent(new CustomEvent('analytics:filter_applied', {
          detail: {
            filter_name: input.name,
            filter_value: String(input.value)
          }
        }));
      } catch (_) {}
      applyFilters(buildUrl(form));
    });

    // Browser back/forward
    window.addEventListener('popstate', () => {
      applyFilters(window.location.pathname + window.location.search, { skipPushState: true });
    });

    // Analytics: view_item_list — fires once on section init
    try {
      document.dispatchEvent(new CustomEvent('analytics:view_item_list', {
        detail: {
          item_list_name: root.dataset.collectionTitle || 'collection',
          items_count: root.querySelectorAll('.product-card').length
        }
      }));
    } catch (_) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var success = document.querySelector('[data-b2b-success]');
    if (success) {
      try {
        document.dispatchEvent(new CustomEvent('analytics:generate_lead', { detail: { source: 'b2b_contact' } }));
      } catch (e) {}
    }

    var retailSuccess = document.querySelector('[data-retail-success]');
    if (retailSuccess) {
      try {
        document.dispatchEvent(new CustomEvent('analytics:generate_lead', { detail: { source: 'retail_contact' } }));
      } catch (e) {}
    }

    if (!document._contactBound) {
      document._contactBound = true;
      document.addEventListener('click', function (event) {
        var link = event.target.closest('[data-retail-link]');
        if (!link) return;
        var source = link.getAttribute('data-retail-link') === 'whatsapp' ? 'whatsapp_click' : 'instagram_click';
        try {
          document.dispatchEvent(new CustomEvent('analytics:generate_lead', { detail: { source: source } }));
        } catch (e) {}
        if (link.dataset.waA) {
          try {
            var n = atob(link.dataset.waA) + atob(link.dataset.waB);
            window.open('https://wa.me/' + n, '_blank', 'noopener');
          } catch (e) {}
        }
      });
    }

    if (!customElements.get('contact-page')) {
      customElements.define('contact-page', class extends HTMLElement {});
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.target;
      this.target = raw ? Date.parse(raw) : NaN;

      this.units = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };

      this.expiredEl = this.querySelector('[data-expired-message]');

      if (isNaN(this.target)) return;

      this.showSeconds = this.dataset.showSeconds === 'true';
      this.update();

      this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
    }

    update() {
      const now = Date.now();
      let diff = this.target - now;
      const expired = diff <= 0;
      if (expired) diff = 0;

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;
      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;
      const minutes = Math.floor(diff / 60000);
      diff -= minutes * 60000;
      const seconds = Math.floor(diff / 1000);

      const pad = (n) => String(n).padStart(2, '0');

      if (this.units.days) this.units.days.textContent = pad(days);
      if (this.units.hours) this.units.hours.textContent = pad(hours);
      if (this.units.minutes) this.units.minutes.textContent = pad(minutes);
      if (this.units.seconds) this.units.seconds.textContent = pad(seconds);

      if (expired) {
        this.setAttribute('data-expired', 'true');
        if (this.expiredEl) this.expiredEl.hidden = false;
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.featured-products__track');
      this.progressBar = this.querySelector('.featured-products__progress-bar');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');

      if (!this.track) return;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.prevBtn?.addEventListener('click', () => this.scrollByCard(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      this.armSnap = () => this.track.classList.add('is-snap-armed');
      ['touchstart', 'pointerdown', 'wheel'].forEach((t) => {
        this.track.addEventListener(t, this.armSnap, { passive: true, once: true });
      });

      this.update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.product-card');
      if (!card) return;
      const cardWidth = card.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }

    onScroll() {
      if (this.rafId) return;
      this.rafId = window.requestAnimationFrame(() => {
        this.update();
        this.rafId = null;
      });
    }

    onResize() {
      this.update();
    }

    update() {
      if (!this.track || !this.progressBar) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      if (scrollWidth <= 0) return;

      const widthFraction = Math.min(1, clientWidth / scrollWidth);
      const offsetFraction = scrollWidth > clientWidth ? scrollLeft / scrollWidth : 0;

      this.progressBar.style.setProperty('--progress-width', `${widthFraction * 100}%`);
      this.progressBar.style.setProperty('--progress-x', `${offsetFraction * 100}%`);

      if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }
  }

  if (!customElements.get('product-carousel')) {
    customElements.define('product-carousel', ProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (document.querySelector('.footer [data-newsletter-success]')) {
    document.dispatchEvent(new CustomEvent('analytics:generate_lead', { detail: { source: 'footer' } }));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero-banner__slide'));
      this.bars = Array.from(this.querySelectorAll('.hero-banner__slider-bar'));
      this.index = 0;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.bars.forEach((bar, i) => {
        bar.addEventListener('click', () => {
          this.goTo(i);
          this.restart();
        });
      });

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.shouldAutoplay = this.dataset.autoplay === 'true' && !reduceMotion;

      if (this.shouldAutoplay) {
        this.start();
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    goTo(target) {
      const next = ((target % this.slides.length) + this.slides.length) % this.slides.length;
      if (next === this.index) return;

      this.slides[this.index].classList.remove('is-active');
      const prevBar = this.bars[this.index];
      if (prevBar) {
        prevBar.classList.remove('is-active');
        prevBar.setAttribute('aria-selected', 'false');
      }

      this.index = next;

      this.slides[this.index].classList.add('is-active');
      const nextBar = this.bars[this.index];
      if (nextBar) {
        nextBar.classList.add('is-active');
        nextBar.setAttribute('aria-selected', 'true');
      }
    }

    start() {
      if (!this.shouldAutoplay) return;
      this.stop();
      const interval = parseInt(this.dataset.interval, 10) || 3000;
      this.timer = window.setInterval(() => this.goTo(this.index + 1), interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('hero-carousel')) {
    customElements.define('hero-carousel', HeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  class InstagramFeed extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.instagram-feed__track');
      this.progressBar = this.querySelector('.instagram-feed__progress-bar');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');

      if (!this.track) return;

      // Live posts: fetch the Behold JSON feed only when the section nears the viewport,
      // so the request never competes with the page's first paint.
      if (this.dataset.feedUrl) {
        this.feedObserver = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.feedObserver.disconnect();
          this.loadFeed();
        }, { rootMargin: '600px 0px' });
        this.feedObserver.observe(this);
      }

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.prevBtn?.addEventListener('click', () => this.scrollByTile(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollByTile(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      this.armSnap = () => this.track.classList.add('is-snap-armed');
      ['touchstart', 'pointerdown', 'wheel'].forEach((t) => {
        this.track.addEventListener(t, this.armSnap, { passive: true, once: true });
      });

      this.update();
    }

    disconnectedCallback() {
      this.feedObserver?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    async loadFeed() {
      try {
        const res = await fetch(this.dataset.feedUrl);
        if (!res.ok) return;
        const data = await res.json();
        const posts = (Array.isArray(data) ? data : data.posts || []).slice(0, 12);
        if (!posts.length || !this.isConnected) return;

        const overlay = this.track.querySelector('.instagram-feed__overlay');
        const tiles = posts.map((post) => this.buildTile(post, overlay));
        this.track.replaceChildren(...tiles);
        this.track.scrollLeft = 0;
        this.update();
      } catch (error) {
        // Network/CORS/JSON failure: keep the curated tiles already on the page.
      }
    }

    buildTile(post, overlay) {
      const sizes = post.sizes || {};
      const pick = sizes.medium || sizes.small || sizes.large || {};
      const src = pick.mediaUrl || (post.mediaType === 'VIDEO' ? post.thumbnailUrl : post.mediaUrl);

      const link = document.createElement('a');
      link.className = 'instagram-feed__tile';
      link.href = post.permalink;
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', this.dataset.tileLabel || 'Open on Instagram');

      const img = document.createElement('img');
      img.className = 'instagram-feed__image';
      img.src = src;
      const srcset = ['small', 'medium', 'large']
        .filter((key) => sizes[key]?.mediaUrl && sizes[key]?.width)
        .map((key) => `${sizes[key].mediaUrl} ${sizes[key].width}w`);
      if (srcset.length) {
        img.srcset = srcset.join(', ');
        img.sizes = '(max-width: 767px) 80vw, (max-width: 1199px) 40vw, 25vw';
      }
      img.width = pick.width || 800;
      img.height = pick.height || 800;
      img.loading = 'lazy';
      img.decoding = 'async';
      // Captions like "Link in bio" make useless alt text; only use ones with some substance.
      const caption = (post.prunedCaption || '').trim();
      const usableCaption = caption.split(/\s+/).length >= 4 ? caption.slice(0, 125) : '';
      img.alt = post.altText || usableCaption || this.dataset.fallbackAlt || '';
      link.append(img);
      if (overlay) link.append(overlay.cloneNode(true));
      return link;
    }

    scrollByTile(direction) {
      const tile = this.track.querySelector('.instagram-feed__tile');
      if (!tile) return;
      const tileWidth = tile.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (tileWidth + gap), behavior: 'smooth' });
    }

    onScroll() {
      if (this.rafId) return;
      this.rafId = window.requestAnimationFrame(() => {
        this.update();
        this.rafId = null;
      });
    }

    onResize() {
      this.update();
    }

    update() {
      if (!this.track || !this.progressBar) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      if (scrollWidth <= 0) return;

      const widthFraction = Math.min(1, clientWidth / scrollWidth);
      const offsetFraction = scrollWidth > clientWidth ? scrollLeft / scrollWidth : 0;

      this.progressBar.style.setProperty('--progress-width', `${widthFraction * 100}%`);
      this.progressBar.style.setProperty('--progress-x', `${offsetFraction * 100}%`);

      if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }
  }

  if (!customElements.get('instagram-feed')) {
    customElements.define('instagram-feed', InstagramFeed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navbar"]) return;
  try {
    
  if (!customElements.get('predictive-search')) {
    class PredictiveSearch extends HTMLElement {
      connectedCallback() {
        this._overlay = this.querySelector('[data-search-overlay]');
        this._input = this.querySelector('[data-search-input]');
        this._results = this.querySelector('[data-search-results]');
        this._openBtn = this.querySelector('[data-search-open]');
        this._closeBtn = this.querySelector('[data-search-close]');
        this._abort = null;
        this._timer = null;
        this._onInput = () => {
          clearTimeout(this._timer);
          this._timer = setTimeout(() => this._search(), 250);
        };
        this._onKeydown = (e) => { if (e.key === 'Escape') this.close(); };
        this._onOpen = () => this.open();
        this._onClose = () => this.close();
        this._openBtn.addEventListener('click', this._onOpen);
        this._closeBtn.addEventListener('click', this._onClose);
        this._input.addEventListener('input', this._onInput);
        document.addEventListener('keydown', this._onKeydown);
      }
      disconnectedCallback() {
        clearTimeout(this._timer);
        if (this._abort) this._abort.abort();
        document.removeEventListener('keydown', this._onKeydown);
      }
      open() {
        this._overlay.hidden = false;
        this._openBtn.setAttribute('aria-expanded', 'true');
        this._input.focus();
      }
      close() {
        clearTimeout(this._timer);
        if (this._abort) this._abort.abort();
        this._overlay.hidden = true;
        this._openBtn.setAttribute('aria-expanded', 'false');
        this._results.hidden = true;
        if (this._openBtn) this._openBtn.focus();
      }
      async _search() {
        const term = this._input.value.trim();
        if (term.length < 2) { this._results.hidden = true; return; }
        if (this._abort) this._abort.abort();
        this._abort = new AbortController();
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const url = `${root}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,collection,query&resources[limit]=4`;
          const res = await fetch(url, { signal: this._abort.signal, headers: { 'Accept': 'application/json' } });
          const data = await res.json();
          this._render(term, (data && data.resources && data.resources.results) || {});
        } catch (e) { /* aborted or failed: keep last results */ }
      }
      _render(term, results) {
        const products = results.products || [];
        const collections = results.collections || [];
        const queries = results.queries || [];
        try {
          document.dispatchEvent(new CustomEvent('analytics:search', {
            detail: { search_term: term, results_count: products.length + collections.length + queries.length }
          }));
        } catch (e) { /* analytics best-effort */ }
        if (!products.length && !collections.length && !queries.length) {
          this._results.innerHTML = `<p class="navbar__search-empty">${this._escape(this.dataset.emptyLabel || '')}</p>`;
          this._results.hidden = false;
          return;
        }
        const esc = this._escape;
        const formatPrice = (p) => {
          if (p == null || p === '') return '';
          const c = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
          const n = Number(p);
          if (Number.isFinite(n)) return `${n.toFixed(2)} ${c}`.trim();
          return String(p);
        };
        const productItem = (r) => `
          <a class="navbar__search-result" href="${esc(r.url || '')}" role="option">
            ${r.featured_image && r.featured_image.url ? `<img src="${esc(r.featured_image.url)}" width="40" height="40" alt="" loading="lazy">` : ''}
            <span>${esc(r.title || '')}</span>
            ${r.price != null && r.price !== '' ? `<span class="navbar__search-price">${esc(formatPrice(r.price))}</span>` : ''}
          </a>`;
        const collectionItem = (r) => `
          <a class="navbar__search-result" href="${esc(r.url || '')}" role="option">
            ${r.featured_image && r.featured_image.url ? `<img src="${esc(r.featured_image.url)}" width="40" height="40" alt="" loading="lazy">` : ''}
            <span>${esc(r.title || '')}</span>
          </a>`;
        const queryItem = (r) => `
          <a class="navbar__search-result" href="${esc(r.url || '')}" role="option">
            <span>${esc(r.text || '')}</span>
          </a>`;
        this._results.innerHTML =
          products.map(productItem).join('') +
          collections.map(collectionItem).join('') +
          queries.map(queryItem).join('');
        this._results.hidden = false;
      }
      _escape(s) {
        return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      }
    }
    customElements.define('predictive-search', PredictiveSearch);
  }

  if (!document._navBadgeBumpBound) {
    document._navBadgeBumpBound = true;
    document.addEventListener('analytics:add_to_cart', () => {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.classList.remove('is-bumping');
        void el.offsetWidth; /* restart animation */
        el.classList.add('is-bumping');
      });
    });
  }

  if (!customElements.get('nav-menu')) {
    class NavMenu extends HTMLElement {
      connectedCallback() {
        this._btn = this.querySelector('[data-menu-toggle]');
        this._panel = this.querySelector('[data-menu-panel]');
        this._scrim = this.querySelector('[data-menu-scrim]');
        this._iconOpen = this.querySelector('[data-menu-icon-open]');
        this._iconClose = this.querySelector('[data-menu-icon-close]');
        if (!this._btn || !this._panel) return;

        this._onKeydown = (e) => {
          if (e.key === 'Escape' && this._isOpen()) this.close(true);
        };
        this._onResize = () => {
          if (window.innerWidth >= 768 && this._isOpen()) this.close(false);
        };

        this._btn.addEventListener('click', () => (this._isOpen() ? this.close(false) : this.open()));
        this._scrim?.addEventListener('click', () => this.close(false));
        this._panel.addEventListener('click', (e) => {
          if (e.target.closest('a')) this.close(false);
        });
        document.addEventListener('keydown', this._onKeydown);
        window.addEventListener('resize', this._onResize, { passive: true });
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this._onKeydown);
        window.removeEventListener('resize', this._onResize);
        document.documentElement.classList.remove('nav-menu-open');
      }

      _isOpen() {
        return this._btn.getAttribute('aria-expanded') === 'true';
      }

      open() {
        this._panel.hidden = false;
        if (this._scrim) this._scrim.hidden = false;
        this._btn.setAttribute('aria-expanded', 'true');
        if (this._iconOpen) this._iconOpen.hidden = true;
        if (this._iconClose) this._iconClose.hidden = false;
        document.documentElement.classList.add('nav-menu-open');
      }

      close(refocus) {
        this._panel.hidden = true;
        if (this._scrim) this._scrim.hidden = true;
        this._btn.setAttribute('aria-expanded', 'false');
        if (this._iconOpen) this._iconOpen.hidden = false;
        if (this._iconClose) this._iconClose.hidden = true;
        document.documentElement.classList.remove('nav-menu-open');
        if (refocus) this._btn.focus();
      }
    }
    customElements.define('nav-menu', NavMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelector('.newsletter [data-newsletter-success]')) {
    document.dispatchEvent(new CustomEvent('analytics:generate_lead', { detail: { source: 'newsletter_section' } }));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-review-modal]').forEach((modal) => {
      const section = modal.closest('section, .shopify-section') || document;
      const openers = section.querySelectorAll('[data-open-review-modal]');
      const closeBtn = modal.querySelector('[data-review-modal-close]');
      const form = modal.querySelector('[data-review-form]');
      const uploadLabel = modal.querySelector('[data-upload-label]');
      const uploadInput = modal.querySelector('[data-upload-input]');
      let lastFocus = null;

      const open = () => {
        lastFocus = document.activeElement;
        modal.hidden = false;
        modal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        const firstInput = modal.querySelector('input, textarea, button');
        firstInput?.focus();
      };

      const close = () => {
        modal.classList.remove('is-open');
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      };

      openers.forEach((b) => b.addEventListener('click', open));
      closeBtn?.addEventListener('click', close);

      modal.addEventListener('click', (e) => {
        if (e.target === modal) close();
      });

      document.addEventListener('keydown', (e) => {
        if (!modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); }
      });

      uploadInput?.addEventListener('change', () => {
        const file = uploadInput.files && uploadInput.files[0];
        if (uploadLabel) uploadLabel.textContent = file ? file.name : uploadLabel.dataset.original || uploadLabel.textContent;
      });
      if (uploadLabel) uploadLabel.dataset.original = uploadLabel.textContent;

      form?.addEventListener('submit', (e) => {
        e.preventDefault();
        const submit = form.querySelector('.review-modal__submit');
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Thanks!';
        }
        setTimeout(() => {
          close();
          form.reset();
          if (submit) {
            submit.disabled = false;
            submit.textContent = submit.dataset.label || submit.textContent;
          }
        }, 900);
        if (submit && !submit.dataset.label) submit.dataset.label = submit.textContent;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-page]');
    if (!root) return;

    // Quantity stepper
    root.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-qty-step]');
      if (!btn) return;
      const input = root.querySelector('.product-page__qty-input');
      if (!input) return;
      const step = parseInt(btn.dataset.qtyStep, 10);
      const current = parseInt(input.value, 10) || 1;
      const next = Math.max(1, Math.min(99, current + step));
      input.value = next;
    });

    // Variant pill change → update hidden variant id by matching options
    function selectedOptions() {
      const radios = root.querySelectorAll('.product-page__variant-radio:checked');
      return Array.from(radios).map(r => r.value);
    }

    let variantMap = {};
    try {
      const mapNode = root.querySelector('[data-variant-map]');
      if (mapNode) variantMap = JSON.parse(mapNode.textContent);
    } catch (e) { /* no-op */ }

    const addLabel = root.dataset.addToCartLabel || 'Add to cart';
    const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';

    // Analytics helpers
    const analyticsEl = root.querySelector('[data-product-analytics]');
    let productMeta = null;
    try {
      if (analyticsEl) productMeta = JSON.parse(analyticsEl.textContent);
    } catch (_) { /* malformed JSON — analytics best-effort */ }
    const track = (name, extra) => {
      if (!productMeta) return;
      document.dispatchEvent(new CustomEvent('analytics:' + name, {
        detail: Object.assign({}, productMeta, extra || {})
      }));
    };
    track('view_item');

    function updateVariant() {
      const key = selectedOptions().join('||');
      const data = variantMap[key];
      if (!data) return;

      const hiddenId = root.querySelector('input[name="id"]');
      if (hiddenId) hiddenId.value = data.id;

      const cta = root.querySelector('.product-page__cta');
      if (cta) {
        cta.disabled = !data.available;
        cta.querySelector('[data-cta-label]').textContent = data.available ? addLabel : soldOutLabel;
      }

      const priceCurrent = root.querySelector('.product-page__price-current');
      if (priceCurrent) priceCurrent.innerHTML = data.price;

      const priceCompare = root.querySelector('.product-page__price-compare');
      if (priceCompare) {
        if (data.compare_at_price) {
          priceCompare.innerHTML = data.compare_at_price;
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }

      // Sticky bar sync
      const stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.innerHTML = data.price;
      const stickyCompare = root.querySelector('[data-sticky-compare]');
      if (stickyCompare) {
        if (data.compare_at_price) {
          stickyCompare.innerHTML = data.compare_at_price;
          stickyCompare.style.display = '';
        } else {
          stickyCompare.style.display = 'none';
        }
      }
      const stickyAdd = root.querySelector('[data-sticky-add]');
      if (stickyAdd) {
        stickyAdd.disabled = !data.available;
        stickyAdd.querySelector('[data-cta-label]').textContent = data.available ? addLabel : soldOutLabel;
      }

      // Update variant meta values
      root.querySelectorAll('.product-page__variant-group').forEach((group, idx) => {
        const value = selectedOptions()[idx];
        const label = group.querySelector('.product-page__variant-meta-value');
        if (label && value) label.textContent = value;
      });

      // Update URL with the variant id (Shopify-style)
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', data.id);
        history.replaceState({}, '', url);
      } catch (e) { /* no-op */ }

      track('variant_selected', { variant_id: data.id, price: data.price_amount });
    }

    root.addEventListener('change', (event) => {
      if (event.target.matches('.product-page__variant-radio')) {
        updateVariant();
      }
    });

    // AJAX add-to-cart → open drawer
    const form = root.querySelector('.product-page__form');
    if (form) {
      form.addEventListener('submit', async (event) => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return; // fall through to default form submit if drawer missing
        event.preventDefault();
        const cta = form.querySelector('.product-page__cta');
        // Swap only the label span so the arrow icon survives.
        const ctaLabel = cta?.querySelector('[data-cta-label]');
        const originalLabel = ctaLabel?.textContent;
        if (cta) { cta.disabled = true; ctaLabel.textContent = '…'; }
        try {
          const data = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: data
          });
          if (!res.ok) throw new Error('add failed');
          try {
            const added = await res.json();
            track('add_to_cart', {
              variant_id: added.variant_id || added.id,
              price: added.price ? added.price / 100 : undefined,
              quantity: added.quantity || 1,
              source: 'pdp'
            });
          } catch (_) { /* analytics best-effort */ }
          await drawer.refresh();
          drawer.open();
        } catch (e) {
          // fallback: regular submit
          form.submit();
        } finally {
          if (cta) { cta.disabled = false; ctaLabel.textContent = originalLabel; }
        }
      });
    }

    // Lightbox
    const lightbox = root.querySelector('[data-lightbox]');
    if (lightbox) {
      const slides = Array.from(lightbox.querySelectorAll('[data-lightbox-slide]'));
      const bars = Array.from(lightbox.querySelectorAll('[data-lightbox-goto]'));
      const total = slides.length;
      let current = 0;
      let lastFocus = null;

      const goto = (idx) => {
        if (total === 0) return;
        current = ((idx % total) + total) % total;
        slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
        bars.forEach((b, i) => b.classList.toggle('is-active', i === current));
      };

      const openAt = (idx) => {
        goto(idx || 0);
        lastFocus = document.activeElement;
        lightbox.hidden = false;
        lightbox.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        lightbox.querySelector('[data-lightbox-close]')?.focus();
      };

      const closeLightbox = () => {
        lightbox.classList.remove('is-open');
        lightbox.hidden = true;
        document.documentElement.style.overflow = '';
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      };

      // Open from main image click — uses active thumb's index when present
      root.querySelector('[data-open-lightbox]')?.addEventListener('click', () => {
        const allThumbs = Array.from(root.querySelectorAll('[data-thumb]'));
        const activeThumb = root.querySelector('[data-thumb].is-active');
        const idx = activeThumb ? allThumbs.indexOf(activeThumb) : 0;
        openAt(idx >= 0 ? idx : 0);
      });

      lightbox.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
      lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => goto(current - 1));
      lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', () => goto(current + 1));
      bars.forEach((b, i) => b.addEventListener('click', () => goto(i)));

      // Click on backdrop (outside stage) closes
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLightbox();
      });

      // Keyboard
      document.addEventListener('keydown', (e) => {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goto(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goto(current + 1); }
      });
    }

    // Sticky CTA → trigger main form submit
    const stickyAddBtn = root.querySelector('[data-sticky-add]');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', () => {
        const mainCta = root.querySelector('.product-page__cta');
        if (mainCta && !mainCta.disabled) mainCta.click();
      });
    }

    // Zoom-on-hover for main product image
    const zoomBtn = root.querySelector('.product-page__main-image');
    const zoomImg = root.querySelector('.product-page__main-img');
    if (zoomBtn && zoomImg && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      zoomBtn.addEventListener('mouseenter', () => zoomBtn.classList.add('is-zoomed'));
      zoomBtn.addEventListener('mouseleave', () => {
        zoomBtn.classList.remove('is-zoomed');
        zoomImg.style.transformOrigin = 'center center';
      });
      zoomBtn.addEventListener('mousemove', (e) => {
        const rect = zoomBtn.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        zoomImg.style.transformOrigin = `${x}% ${y}%`;
      });
    }

    // Gallery: thumb click + prev/next arrows → switch main image
    const allThumbs = () => Array.from(root.querySelectorAll('[data-thumb]'));

    const activateGalleryThumb = (thumb) => {
      if (!thumb) return;
      allThumbs().forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      // Keep the active thumb in view inside its own strip (vertical on desktop, horizontal on mobile) without moving the page
      const strip = thumb.closest('.product-page__thumbs');
      if (strip) {
        strip.scrollTo({
          top: thumb.offsetTop - (strip.clientHeight - thumb.offsetHeight) / 2,
          left: thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2,
          behavior: 'smooth',
        });
      }
      const thumbImg = thumb.querySelector('img');
      const main = root.querySelector('.product-page__main-img');
      if (!main || !thumbImg) return;
      const baseSrc = thumbImg.src.replace(/width=\d+/, 'width=2090');
      // Rebuild srcset for the new image so the browser actually picks it
      main.srcset = ['480', '800', '1200', '1600', '2090']
        .map(w => `${baseSrc.replace(/width=\d+/, 'width=' + w)} ${w}w`)
        .join(', ');
      main.src = baseSrc;
    };

    const stepGallery = (delta) => {
      const thumbs = allThumbs();
      if (thumbs.length === 0) return;
      const activeIndex = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
      const nextIndex = ((activeIndex + delta) % thumbs.length + thumbs.length) % thumbs.length;
      activateGalleryThumb(thumbs[nextIndex]);
    };

    root.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-thumb]');
      if (thumb) {
        activateGalleryThumb(thumb);
        return;
      }
      if (event.target.closest('[data-gallery-prev]')) {
        event.preventDefault();
        event.stopPropagation();
        stepGallery(-1);
        return;
      }
      if (event.target.closest('[data-gallery-next]')) {
        event.preventDefault();
        event.stopPropagation();
        stepGallery(1);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  const el = document.querySelector('.search-page');
  if (el && el.dataset.searchTerm) {
    try {
      document.dispatchEvent(new CustomEvent('analytics:search', {
        detail: { search_term: el.dataset.searchTerm, results_count: Number(el.dataset.resultsCount || 0), source: 'search_page' }
      }));
    } catch (e) { /* analytics best-effort */ }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  // Infinite loop: a clone of the last slide sits before the first and a clone of the
  // first after the last. We animate onto a clone, then jump (no transition) to the real
  // slide it mirrors, so the carousel always moves in the clicked direction.
  class TestimonialCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.testimonials__track');
      if (!this.track) return;
      this.track.querySelectorAll('[data-clone]').forEach((el) => el.remove());
      this.slides = Array.from(this.track.querySelectorAll('.testimonials__slide'));
      this.count = this.slides.length;
      if (this.count < 2) return;

      const makeClone = (slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        clone.removeAttribute('data-shopify-editor-block');
        return clone;
      };
      this.track.prepend(makeClone(this.slides[this.count - 1]));
      this.track.append(makeClone(this.slides[0]));
      this.bars = Array.from(this.querySelectorAll('.testimonials__progress-bar'));

      this.position = 1;
      this.busy = false;
      this.onClick = (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button || !this.contains(button)) return;
        this.move(button.dataset.direction === 'next' ? 1 : -1);
      };
      this.onTransitionEnd = (event) => {
        if (event.target === this.track && event.propertyName === 'transform') this.settle();
      };
      // Swipe: horizontal drags change slide; vertical ones stay page scroll (touch-action: pan-y).
      this.onPointerDown = (event) => {
        if (event.pointerType === 'mouse') return;
        this.swipeStart = { x: event.clientX, y: event.clientY };
      };
      this.onPointerUp = (event) => {
        if (!this.swipeStart) return;
        const dx = event.clientX - this.swipeStart.x;
        const dy = event.clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.move(dx < 0 ? 1 : -1);
      };
      this.onPointerCancel = () => { this.swipeStart = null; };
      this.addEventListener('click', this.onClick);
      this.track.addEventListener('transitionend', this.onTransitionEnd);
      this.viewport = this.querySelector('.testimonials__viewport');
      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      this.viewport.addEventListener('pointerup', this.onPointerUp);
      this.viewport.addEventListener('pointercancel', this.onPointerCancel);
      this.render(false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.track?.removeEventListener('transitionend', this.onTransitionEnd);
      this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport?.removeEventListener('pointerup', this.onPointerUp);
      this.viewport?.removeEventListener('pointercancel', this.onPointerCancel);
      clearTimeout(this.settleTimer);
    }

    move(delta) {
      if (this.busy) return;
      this.busy = true;
      this.position += delta;
      this.render(true);
      // Fallback for reduced motion (no transition → no transitionend) or a hidden tab.
      const duration = parseFloat(getComputedStyle(this.track).transitionDuration) || 0;
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), duration * 1000 + 50);
    }

    settle() {
      clearTimeout(this.settleTimer);
      if (this.position === 0) this.position = this.count;
      else if (this.position === this.count + 1) this.position = 1;
      this.render(false);
      this.busy = false;
    }

    render(animate) {
      if (!animate) this.track.style.transition = 'none';
      this.track.style.transform = `translateX(-${this.position * 100}%)`;
      if (!animate) {
        void this.track.offsetWidth;
        this.track.style.transition = '';
      }
      const index = (this.position - 1 + this.count) % this.count;
      const fraction = 1 / this.count;
      this.bars.forEach((bar) => {
        bar.style.setProperty('--progress-width', `${fraction * 100}%`);
        bar.style.setProperty('--progress-x', `${index * fraction * 100}%`);
      });
    }
  }

  if (!customElements.get('testimonial-carousel')) {
    customElements.define('testimonial-carousel', TestimonialCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
